

import {AfterViewChecked, AfterViewInit, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {PlatformSettings} from '../../models/platform-settings/platform-settings';
import {UserService} from '../services/user.service';
import {AccountLevelsUsage} from '../../models/user';

export abstract class AbstractAchooComponent implements OnDestroy, AfterViewInit, AfterViewChecked, OnInit {
  private companySubscription: Subscription;
  private platformSettingSubscription: Subscription;
  private accountLevelsSubscription: Subscription;

  protected companyId: number;
  protected platformSettings: PlatformSettings;
  protected accountLevels: AccountLevelsUsage;

  // [IMPORTANT] Property for ignore checking inactive account when change company
  // Calling most of APIs with inacctive account will lead to HTTP 403
  // Exception case: Account Settings page
  protected allowInactiveAccount = false;

  constructor(protected userService: UserService) {
  }

  ngOnInit() {
    this.companySubscription = this.userService.companyId.subscribe(value => {
      if (value) {
        if (!this.allowInactiveAccount) {
          const ad = this.userService.getCurrentAdvertiser();
          const canGoNext = ad && !ad.inactive;

          if (!canGoNext) { return; }
        }

        this.companyId = value;
        this.companyChangeCallback(value);
      }
    });

   this.setupPlatformSettingSubscription();

    this.accountLevelsSubscription = this.userService.accountLevels.subscribe(level => {
      this.accountLevels = level;
    });
  }

  ngOnDestroy() {
    if (this.companySubscription) {
      this.companySubscription.unsubscribe();
    }

    this.destroyPlatformSettingSubscription();
  }

  ngAfterViewInit() {

  }

  ngAfterViewChecked() {
    this.updateBottomBarBackground(this.platformSettings);
  }

  protected setupPlatformSettingSubscription() {
    this.platformSettingSubscription = this.userService.platformSettings.subscribe(setting => {
      this.platformSettings = setting;
      this.updateBottomBarBackground(setting);
    });
  }

  protected destroyPlatformSettingSubscription() {
    if (this.platformSettingSubscription) {
      this.platformSettingSubscription.unsubscribe();
    }
  }

  private updateBottomBarBackground(platformSettings) {
    if (this.userService.isSsoUser) {
      return;
    }

    const bottomBar = document.querySelector('.bottombar') as HTMLElement;

    if (bottomBar && platformSettings) {
      bottomBar.style.backgroundColor = platformSettings.bottombarBgColor;

      const greenButtons = bottomBar.querySelectorAll('button.green');
      [].forEach.call(greenButtons, (button) => {
        button.style.backgroundColor = platformSettings.bottombarButtonColors[0];
      });

      const blueButtons = bottomBar.querySelectorAll('button.blue');
      [].forEach.call(blueButtons, (button) => {
        button.style.backgroundColor = platformSettings.bottombarButtonColors[1];
      });

      const redButtons = bottomBar.querySelectorAll('button.red');
      [].forEach.call(redButtons, (button) => {
        button.style.backgroundColor = platformSettings.bottombarButtonColors[2];
      });

      const greyButtons = bottomBar.querySelectorAll('button.gray');
      [].forEach.call(greyButtons, (button) => {
        button.style.backgroundColor = platformSettings.bottombarButtonColors[3];
      });

      const ngPopper = bottomBar.querySelectorAll('.ngx-popper');
      [].forEach.call(ngPopper, (popper) => {
        popper.style.backgroundColor = platformSettings.bottombarBgColor;
      });
    }
  }


  abstract companyChangeCallback(companyId);
}



// WEBPACK FOOTER //
// ./src/app/main/abstract-achoo.component.ts